var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      staticClass: "category-banner",
      attrs: {
        href: _vm.getBannerData(_vm.data, ["body", "url"]),
        target: _vm.getBannerData(_vm.data, ["body", "target"])
      },
      on: { click: _vm.onClick }
    },
    [
      _c("img", {
        staticClass: "category-banner__backgound-img",
        attrs: {
          src: _vm.getBannerData(_vm.data, ["body", "image"]),
          alt: _vm.getBannerData(_vm.data, ["body", "alt"])
        }
      }),
      _c("span", { staticClass: "category-banner__caption" }, [
        _vm._v(
          "\n    " +
            _vm._s(_vm.getBannerData(_vm.data, ["text", "title"])) +
            "\n  "
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }